import { useEffect, useState } from 'react';
import type { Fetcher, FetcherWithComponents } from 'react-router-dom';
import { useFetcher } from 'react-router-dom';

export type FetcherWithComponentsReset<T> = FetcherWithComponents<T> & {
  reset: () => void;
};

function getDoneFetcher(data: Fetcher['data']) {
  return {
    state: 'idle',
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined,
    data,
  } as const;
}

// TODO: useFetcher.fetcher added support for native reset with version 7.10.0
export function useFetcherWithReset<TData = unknown>(
  opts?: Parameters<typeof useFetcher>[0],
): FetcherWithComponentsReset<TData> {
  const fetcher = useFetcher<TData>(opts);
  const [fetcherState, setFetcherState] = useState<Fetcher>(fetcher);

  useEffect(() => {
    setFetcherState(fetcher);
  }, [fetcher]);

  function resetFetcher() {
    setFetcherState(getDoneFetcher(undefined));
  }

  return {
    ...fetcher,
    ...fetcherState,
    reset: () => resetFetcher(),
  };
}
